export const ABBONATI_SKY_FOLDER_ID = 23;
export const DOCUMENTI_ECONOMICO_FINANZIARI_ID = 25;
export const ABBONATI_FOLDER_ID = 30;
export const LISTINO_FOLDER_ID = 31;
export const DIGITAL_PLATFORMS_FOLDER_ID = 32;
export const RAI_RTI_PROGRAMS_FOLDER_ID = 33;
export const DEFAULT_BROADCASTER_ID = 63; // DAZN

// import {ABBONATI_SKY_FOLDER_ID, DOCUMENTI_ECONOMICO_FINANZIARI_ID, ABBONATI_FOLDER_ID, LISTINO_FOLDER_ID, DEFAULT_BROADCASTER_ID} from "../../constants/specialFolders";